<template>
    <set-azure-arm-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAzureArmAccount')"
        :edit="edit"
        :disabled="{ ...(disabled || {}), Name: true, UseTenantCurrencies: true }"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <put-credential-button
                type="AzureActiveDirectoryApplicationCredential"
                :value="{ ...edit, ...form }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAzureArmAccount'"
                @http2xx="acceptSubmit($event, close)"
            ></put-credential-button>
        </template>
    </set-azure-arm-credentials-dialog>
</template>

<script>
import SetAzureArmCredentialsDialog from '@/components/Settings.CloudAccounts/Azure/SetAzureARMCredentialsDialog';
import PutCredentialButton from '@/components/Settings.CloudAccounts/PutCredentialButton';
export default {
    components: { SetAzureArmCredentialsDialog, PutCredentialButton },
    props: {
        value: Boolean,
        edit: Object,
        disabled: Object,
    },
    methods: {
        async acceptSubmit($event, close) {
            await close();
            this.$emit('http2xx', $event);
        },
    },
};
</script>